import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Divider, isValidObject, WHITE, getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getInvestmentDetailsWidgetStyles } from './InvestmentDetailsWidgetStyles';
import { LinkListItemWidget } from '../link-list-item-widget';
import { InvestmentBreakupItem } from './components/investment-breakup-item';
export var InvestmentDetailsWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'InvestmentDetailsWidget' : _props$testID,
    style = props.style,
    _props$linkListItemPr = props.linkListItemProps,
    linkListItemProps = _props$linkListItemPr === void 0 ? {} : _props$linkListItemPr,
    showDivider = props.showDivider,
    _props$dividerProps = props.dividerProps,
    dividerProps = _props$dividerProps === void 0 ? {} : _props$dividerProps,
    _props$list = props.list,
    list = _props$list === void 0 ? [] : _props$list;
  var investmentDetailsWidgetStyles = getInvestmentDetailsWidgetStyles();
  return _jsxs(Card, Object.assign({
    paddingToken: "SPACING_0",
    style: [investmentDetailsWidgetStyles.containerStyle, style]
  }, getTestId(testID, 'investmentDetailsWrapper'), {
    children: [isValidObject(linkListItemProps) && _jsxs(_Fragment, {
      children: [_jsx(LinkListItemWidget, Object.assign({}, linkListItemProps)), showDivider && _jsx(View, Object.assign({
        style: dividerProps
      }, {
        children: _jsx(Divider, {
          height: 2,
          shadowColor: WHITE
        })
      }))]
    }), list === null || list === void 0 ? void 0 : list.map((item, index) => _jsx(InvestmentBreakupItem, Object.assign({}, item, {
      testID: testID + "_investmentBreakup_" + index
    }), "investment_breakup_" + index))]
  }));
};
InvestmentDetailsWidgetComponent.genericRendererKey = 'AirInvestmentDetailsWidget';